import type { AdminQueryPort } from "../../contracts/admin-query-port";
import type {
  AdminJobData,
  AdminJobPage,
  AdminJobQuery,
  AdminQueryEnvelope,
} from "../../contracts/admin-read-models";

export type AdminJobBacklogSummary = {
  totalCountLabel: string;
  queuedCountLabel: string;
  processingCountLabel: string;
  failedCountLabel: string;
};

export async function searchJobs(
  port: AdminQueryPort,
  query: AdminJobQuery,
): Promise<AdminQueryEnvelope<AdminJobPage>> {
  return port.searchJobs(query);
}

export function summarizeJobBacklog(jobs: AdminJobData[]): {
  totalCount: number;
  queuedCount: number;
  processingCount: number;
  failedCount: number;
} {
  return {
    totalCount: jobs.length,
    queuedCount: jobs.filter((job) => job.status === "queued").length,
    processingCount: jobs.filter((job) => job.status === "processing").length,
    failedCount: jobs.filter((job) => job.status === "failed").length,
  };
}
